import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import './RedemptionRequests.css';

const RedemptionRequests = () => {
    const [redemptions, setRedemptions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filter, setFilter] = useState('pending'); // 'pending', 'paid', 'rejected', 'all'
    const { currentUser } = useAuth();

    useEffect(() => {
        if (currentUser) {
            fetchRedemptions();
        }
    }, [currentUser]);

    const fetchRedemptions = async () => {
        try {
            const token = await currentUser.getIdToken();
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/admin/redemptions`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            // Ordenar por data (mais recente primeiro)
            const sorted = response.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
            setRedemptions(sorted);
        } catch (error) {
            console.error("Erro ao buscar resgates:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleProcess = async (id, action) => {
        if (!window.confirm(`Tem certeza que deseja ${action === 'pay' ? 'pagar' : 'rejeitar'} este resgate?`)) return;

        const adminNotes = prompt("Observações (opcional):");

        try {
            const token = await currentUser.getIdToken();
            await axios.put(`${process.env.REACT_APP_API_URL}/admin/redemptions/${id}/process`, {
                action,
                adminNotes
            }, {
                headers: { Authorization: `Bearer ${token}` }
            });

            alert(`Resgate ${action === 'pay' ? 'pago' : 'rejeitado'} com sucesso!`);
            fetchRedemptions();
        } catch (error) {
            console.error("Erro ao processar:", error);
            alert("Erro ao processar resgate.");
        }
    };

    const filteredRedemptions = redemptions.filter(r => {
        if (filter === 'all') return true;
        return r.status === filter;
    });

    if (loading) return <div className="loading">Carregando solicitações...</div>;

    return (
        <div className="redemptions-container">
            <div className="page-header">
                <h1>Solicitações de Resgate</h1>
                <div className="filters">
                    <button className={filter === 'pending' ? 'active' : ''} onClick={() => setFilter('pending')}>Pendentes</button>
                    <button className={filter === 'paid' ? 'active' : ''} onClick={() => setFilter('paid')}>Pagos</button>
                    <button className={filter === 'rejected' ? 'active' : ''} onClick={() => setFilter('rejected')}>Rejeitados</button>
                    <button className={filter === 'all' ? 'active' : ''} onClick={() => setFilter('all')}>Todos</button>
                </div>
            </div>

            <div className="redemptions-list">
                {filteredRedemptions.length > 0 ? (
                    filteredRedemptions.map(redemption => (
                        <div key={redemption.id} className={`redemption-card status-${redemption.status}`}>
                            <div className="redemption-header">
                                <span className="redemption-id">#{redemption.id.split('_')[1]}</span>
                                <span className={`status-badge ${redemption.status}`}>
                                    {redemption.status === 'pending' ? 'Pendente' :
                                        redemption.status === 'paid' ? 'Pago' : 'Rejeitado'}
                                </span>
                            </div>

                            <div className="redemption-body">
                                <div className="info-group">
                                    <label>Usuário (ID)</label>
                                    <p>{redemption.userId}</p>
                                </div>
                                <div className="info-group">
                                    <label>Prêmio</label>
                                    <p className="highlight">{redemption.rewardTitle}</p>
                                </div>
                                <div className="info-group">
                                    <label>Custo</label>
                                    <p>{redemption.cost} moedas</p>
                                </div>
                                <div className="info-group full-width">
                                    <label>Dados de Envio</label>
                                    <p className="payment-details">
                                        {redemption.pixKey ? `Chave Pix: ${redemption.pixKey}` : redemption.details}
                                    </p>
                                </div>
                                <div className="info-group">
                                    <label>Data Solicitação</label>
                                    <p>{new Date(redemption.createdAt).toLocaleString()}</p>
                                </div>
                                {redemption.processedAt && (
                                    <div className="info-group">
                                        <label>Processado em</label>
                                        <p>{new Date(redemption.processedAt).toLocaleString()}</p>
                                    </div>
                                )}
                            </div>

                            {redemption.status === 'pending' && (
                                <div className="redemption-actions">
                                    <button className="btn-reject" onClick={() => handleProcess(redemption.id, 'reject')}>
                                        <i className="fas fa-times"></i> Rejeitar
                                    </button>
                                    <button className="btn-approve" onClick={() => handleProcess(redemption.id, 'pay')}>
                                        <i className="fas fa-check"></i> Marcar como Pago
                                    </button>
                                </div>
                            )}
                        </div>
                    ))
                ) : (
                    <div className="no-results">Nenhuma solicitação encontrada neste filtro.</div>
                )}
            </div>
        </div>
    );
};

export default RedemptionRequests;
